import { render, staticRenderFns } from "./litter-reminder-and-notes-container.vue?vue&type=template&id=6c7038fb&scoped=true&lang=pug"
import script from "./litter-reminder-and-notes-container.js?vue&type=script&lang=js&external"
export * from "./litter-reminder-and-notes-container.js?vue&type=script&lang=js&external"
import style0 from "./litter-reminder-and-notes-container.vue?vue&type=style&index=0&id=6c7038fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7038fb",
  null
  
)

export default component.exports